<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Baixa de Requisições</h2>
      </v-card-title>
      <v-card-text>
        <e-data-table4
          :headers="headers"
          :items="requisicoes"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @edit="editItem"
        ></e-data-table4>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import requisicaoService from '@/services/requisicao'
import EDataTable4 from '@/components/EDataTable4'
import { showError, retPermissao } from '@/utils'

export default {
  name: 'requisicaoBaixa',
  components: {
    EDataTable4
  },
  data () {
    return {
      search: '',
      requisicoes: [],
      total: 0,
      headers: [
        { text: 'Fornecedor', value: 'fornecedor', sortable: false },
        { text: 'Data', value: 'data_lancto', sortable: false },
        { text: 'Veículo', value: 'veiculo', sortable: false },
        { text: 'Plano', value: 'plano', sortable: false },
        { text: 'Odômetro inicio', value: 'odometro_anterior', sortable: false },
        { text: 'Odômetro fim', value: 'odometro', sortable: false },
        { text: 'Km rodado', value: 'kmrodado', sortable: false },
        { text: 'Qtde', value: 'litros', sortable: false },
        { text: 'Valor', value: 'valor_total', sortable: false }],
      valid: true,
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await requisicaoService.getByBaixa(page) : await requisicaoService.getByVeiculo(search, page)
        this.total = result._meta.total_items
        this.requisicoes = result.data
      } catch (error) {
        this.viagens = []
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Requisições Baixa', 'alterar')
      if (ret === true) {
        this.$router.push(`/requisicoesbaixa/editar/${item.id}/${item.fk_empresa}`)
      }
    }
  }
}
</script>
